// document.body.addEventListener("ready.productSamples", function (result) {
//   var data = result.detail;
//   console.log(data);
//   console.log('App is ready!');
// });

class ReinitSampleAppButtonItem extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (window.ProductSamplesApp && window.ProductSamplesApp.reInitButton) {
      window.ProductSamplesApp.reInitButton();
    }
  }
}
window.customElements.define("reinit-sample-app-button-item", ReinitSampleAppButtonItem);
